import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AppConfiguration } from '../../../bootstrap/climatecare/app.configuration';
import { FfpEncryptorService } from '../ffp-encryptor/ffp-encryptor.service';
import { CnAirAccrualRequest } from './cn-air-accrual-request.interface';
import { CnAirAccrualResponse } from './cn-air-accrual-response.interface';

const RTN_CODE_SUCCESS = '000';

@Injectable({ providedIn: 'root' })
export class CnAirMapService {

  constructor(
    private httpClient: HttpClient,
    private appConfiguration: AppConfiguration,
    private ffpEncryptor: FfpEncryptorService) { }

  async createAccrualCarbonOffsetPoints(request: CnAirAccrualRequest): Promise<CnAirAccrualResponse> {
    if (!this.isClient('chinaair')) {
      return null;
    }

    const map = this.appConfiguration.clientConfiguration.clientSettings.webService.cnAir.map;

    const timestampUtc = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss', 'en-US', 'UTC');
    const signature = await this.ffpEncryptor.encrypt(JSON.stringify({
      Name: map.userID,
      Pwd: map.PWD,
      Timestamp_Utc: timestampUtc
    }));

    const headers = new HttpHeaders({
      'Client-ID': map.userID,
      Signature: signature
    });

    const response = await this.httpClient.post<CnAirAccrualResponse>(map.api, request, { headers }).toPromise();

    if (response.RtnCode !== RTN_CODE_SUCCESS) {
      const error: any = new Error(response.RtnDesc || `CnAir accrual request failed (${response.RtnCode})`);
      error.rtnCode = response.RtnCode;
      throw error;
    }

    return response;
  }

  private isClient(client: string): boolean {
    let clientFound = false;

    const calcClient =
      this.appConfiguration.clientConfiguration.clientSettings.client;

    if (calcClient === client) {
      clientFound = true;
    }

    return clientFound;
  }
}
